import { Icon } from "@iconify/react/dist/iconify.js";
import { Divider, Group, Box, Stack, Paper, Button, Text } from "@mantine/core";
import { useActions } from "src/state"
import {  GuidelineFragment } from "src/state/gql/_types";

type GuidelinesListProps = {
    title: string;
    icon?: string;
    guidelines: GuidelineFragment[];
    track_tenant?: boolean;
    track_venue?: boolean;
    track_talent?: boolean;
}

export function GuidelinesList({
    title,
    icon = 'ph:list-checks-duotone',
    guidelines,
    track_tenant = false,
    track_venue = false,
    track_talent = false,
}: GuidelinesListProps) {

    const { selectItem } = useActions().guidelines;

    const handleSelect = (guideline: GuidelineFragment) => {
        selectItem(guideline.id);
    }

    if (guidelines.length === 0) {
        return null;
    }

    return (
        <Stack mt="md">

            <Divider
                my="0"
                variant="dashed"
                labelPosition="left"
                color="var(--mantine-color-gray-4)"
                styles={{
                    label: {
                        color: 'var(--mantine-color-gray-7)',
                        fontWeight: 400,
                        fontSize: '16px',
                    }
                }}
                label={
                    <Group gap="3" align="center" justify="flex-start">
                        <Icon icon={icon} width={20} />
                        <Box ml={5}>{title}</Box>
                    </Group>
                }
            />

            <Stack gap="4">
                {guidelines.length === 0 && (
                    <Text c="dimmed" size="xs" ta="center">
                        No pending {title}
                    </Text>
                )}
                {guidelines.map((guideline) => {

                    const isRequired = track_tenant && guideline.tenant_required || track_venue && guideline.venue_required || track_talent && guideline.talent_required;

                    const isTenantValid = track_tenant && guideline.tenant_required ? guideline.tenant_confirmed || guideline.talent_completed : true;
                    const isVenueValid = track_venue && guideline.venue_required ? guideline.venue_confirmed || guideline.venue_completed : true;
                    const isTalentValid = track_talent && guideline.talent_required ? guideline.talent_confirmed || guideline.talent_completed : true;

                    const isValid = isTenantValid && isVenueValid && isTalentValid;
                    
                    return (
                        <Paper key={guideline.id} p="xs" radius="md" shadow="0" withBorder style={{ borderColor: !isRequired ? 'var(--mantine-color-gray-4)' : isValid ? 'var(--mantine-color-green-8)' : 'var(--mantine-color-red-6)' }}>
                            <Group gap="8" align="flex-start" justify="space-between" wrap="nowrap">
                                <Group gap="6" align="flex-start" wrap="nowrap">
                                    <Icon
                                        icon={!isRequired ? 'ph:info-duotone' : isValid ? 'ph:check-circle-duotone' : 'ph:warning-duotone'}
                                        width={16}
                                        style={{ flexShrink: 0, marginTop: 0, color: !isRequired ? 'var(--mantine-color-gray-7)' : isValid ? 'var(--mantine-color-green-8)' : 'var(--mantine-color-red-6)' }}
                                    />
                                    <Box>
                                        <Box fz="sm" fw={500} lh={1.2}>{guideline.name}</Box>
                                        {guideline.description && (
                                            <Box fz="xs" c="dimmed" lh={1.2}>{guideline.description}</Box>
                                        )}
                                    </Box>
                                </Group>
                                <Button
                                        mt="auto"
                                        variant="outline"
                                        size="xs"
                                        color="gray"
                                        onClick={() => handleSelect(guideline)}
                                        style={{ flexShrink: 0 }}
                                    >
                                        Review
                                </Button>
                            </Group>
                        </Paper>
                    );
                })}
            </Stack>

        </Stack>
    )

}